import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const Feestructure = () => {
     useEffect(() => {
        document.title = 'Fee Structure -  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li> 
<li>  Admission  </li> 
     <li>Fee Structure 2026-2027 </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>Fee Structure 2026-2027 </h1>
         </div>
     </div>
     <div className="row">
       <div className="col-lg-12">

<div class="table-responsive maintable">
  <table class="table" border="1">
    <thead>
      <tr>
        <th colspan="13">
          FEE STRUCTURE FOR 2026–2027 (Monthly)
        </th>
      </tr>
      <tr>
        <th></th>
        <th>Nur - UKG</th>
        <th>Class 1st</th>
        <th>Class 2nd</th>
        <th>Class 3rd</th>
        <th>Class 4th</th>
        <th>Class 5th</th>
        <th>Class 6th</th>
        <th>Class 7th</th>
        <th>Class 8th</th>
        <th>Class 9th</th>
        <th>Class 10th</th>
      
      </tr>
    </thead>
    <tbody>
      {/* <tr><td>TUITION FEE</td><td>2795</td><td>3114</td><td>3114</td><td>3114</td><td>3114</td><td>3114</td><td>3337</td><td>3337</td><td>3337</td><td>3337</td><td>3560</td></tr>
      <tr><td>CONVENIENCE FEE</td><td>540</td><td>250</td><td>250</td><td>250</td><td>250</td><td>250</td><td>250</td><td>250</td><td>250</td><td>250</td><td>250</td></tr>
      <tr><td>MULTIMEDIA</td><td>507</td><td>462</td><td>469</td><td>476</td><td>482</td><td>489</td><td>470</td><td>521</td><td>532</td><td>543</td><td>581</td></tr>
      <tr><td>ANNUAL FEE</td><td>684</td><td>795</td><td>801</td><td>808</td><td>814</td><td>821</td><td>802</td><td>853</td><td>864</td><td>875</td><td>913</td></tr>
      <tr><td>EXAMINATION FEE</td><td>140</td><td>161</td><td>167</td><td>174</td><td>181</td><td>187</td><td>168</td><td>219</td><td>231</td><td>242</td><td>279</td></tr>
      <tr><td>COMPUTER FEE</td><td>-</td><td>201</td><td>208</td><td>214</td><td>221</td><td>228</td><td>209</td><td>260</td><td>271</td><td>282</td><td>320</td></tr>
      <tr><td>LIBRARY FEE</td><td>-</td><td>80</td><td>87</td><td>94</td><td>101</td><td>107</td><td>88</td><td>139</td><td>151</td><td>162</td><td>199</td></tr>
      <tr><td>LAB FEE</td><td>-</td><td>-</td><td>-</td><td>-</td><td>-</td><td>-</td><td>146</td><td>197</td><td>208</td><td>219</td><td>257</td></tr> */}
      <tr>
        <td>TOTAL</td>
        <td>4833</td><td>5083</td><td>5217</td><td>5350</td><td>5483</td>
        <td>5617</td><td>5750</td><td>5883</td><td>6117</td><td>6350</td><td>6500</td>
      </tr>
    </tbody>
  </table>
</div>
<br />
<div class="table-responsive maintable">
  <table class="table" border="1">
    <thead>
      <tr>
        <th colspan="3">
          CLASS 11 FEE STRUCTURE FOR 2026–2027 (Monthly)
        </th>
      </tr>
      <tr>
        <th>Stream</th>
        <th>With IT</th>
        <th>Without IT</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Non Medical</td>
        <td>9350</td>
        <td>9517</td>
      </tr>
      <tr>
        <td>Medical</td>
        <td>9517</td>
        <td>9517</td>
      </tr>
      <tr>
        <td>Commerce</td>
        <td>7750</td>
        <td>7583</td>
      </tr>
    </tbody>
  </table>
</div>
<br />
<div class="table-responsive maintable">
  <table class="table" border="1">
    {/* <thead>
      <tr>
        <th colspan="13">
          FEE STRUCTURE FOR 2026–2027 (Monthly)
        </th>
      </tr>
      <tr>
        <th></th>
        <th>Nur - UKG</th>
        <th>Class 1st</th>
        <th>Class 2nd</th>
        <th>Class 3rd</th>
        <th>Class 4th</th>
        <th>Class 5th</th>
        <th>Class 6th</th>
        <th>Class 7th</th>
        <th>Class 8th</th>
        <th>Class 9th</th>
        <th>Class 10th</th>
        <th>Class 11th</th>
      </tr>
    </thead> */}
    {/* <tbody>
      <tr>
        <td>TOTAL</td>
        <td>4833</td><td>5083</td><td>5217</td><td>5350</td><td>5483</td>
        <td>5617</td><td>5750</td><td>5883</td><td>6117</td><td>6350</td><td>6500</td><td>-</td>
      </tr>
    </tbody> */}
  </table>
</div>


       {/* <div class="table-responsive maintable">
                <table class="table">
                    <thead>
                    <tr>
                    <th></th>
                    <th>Nur - UKG </th> <th>Class 1st </th> <th>Class 2nd </th> <th>Class 3rd </th> <th>Class 4th </th> <th>Class 5th </th> <th>Class 6th </th> <th>Class 7th </th> <th>Class 8th </th> <th>Class 9th </th> <th>Class 10th</th>
                    </tr>
                    </thead>
                <tbody>
                <tr><td>TUITION FEE</td><td>8386</td><td>9342</td><td>9342</td><td>9342</td><td>9342</td><td>9342</td><td>9342</td><td>10011</td><td>10011</td><td>10011</td><td>10680</td></tr>
                <tr><td>CONVENIENCE FEE</td><td>1621</td><td>750</td><td>750</td><td>750</td><td>750</td><td>750</td><td>750</td><td>750</td><td>750</td><td>750</td><td>750</td></tr>
                <tr><td>MULTIMEDIA</td><td>1521</td><td>1386</td><td>1407</td><td>1427</td><td>1447</td><td>1467</td><td>1410</td><td>1563</td><td>1596</td><td>1630</td><td>1744</td></tr>
                <tr><td>ANNUAL FEE</td><td>2051</td><td>2384</td><td>2403</td><td>2423</td><td>2443</td><td>2463</td><td>2406</td><td>2559</td><td>2592</td><td>2625</td><td>2738</td></tr>
                <tr><td>EXAMINATION FEE</td><td>421</td><td>483</td><td>502</td><td>522</td><td>542</td><td>562</td><td>504</td><td>658</td><td>692</td><td>725</td><td>838</td></tr>
                <tr><td>COMPUTER FEE</td><td>-</td><td>603</td><td>623</td><td>643</td><td>663</td><td>683</td><td>626</td><td>780</td><td>813</td><td>846</td><td>960</td></tr>
                <tr><td>LIBRARY FEE</td><td>-</td><td>241</td><td>262</td><td>282</td><td>302</td><td>322</td><td>264</td><td>418</td><td>452</td><td>485</td><td>598</td></tr>
                <tr><td>LAB FEE</td><td>-</td><td>-</td><td>-</td><td>-</td><td>-</td><td>-</td><td>438</td><td>591</td><td>624</td><td>658</td><td>772</td></tr>
                <tr><td><strong>TOTAL</strong></td><td>14000</td><td>15189</td><td>15289</td><td>15389</td><td>15489</td><td>15589</td><td>15740</td><td>17330</td><td>17530</td><td>17730</td><td>19080</td></tr>
                </tbody>
                </table>
                </div> */}
       </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default Feestructure


